// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"8caa8f8a","155":"6098769e","210":"b3bab53a","542":"f92a9d6e","586":"67d76b71","772":"89ceac3f","921":"7bbb5eac"}[chunkId] + ".css";
};